module.exports = __webpack_public_path__ + "media/images/close-icon-9be33c510bd58aa095c18ceab4175ae7.svg";